<template>
  <div class="box">
    <p class="description" v-html="theory.description"></p>
    <div class="video" v-if="theory.link">
      <video-player
        :videoId="theory.link"
        :resourceId="theory.id"
        :dropboxLink="getDropboxLink"
      />
    </div>
    <div class="images" v-if="theory.images && theory.images.length > 0">
      <img
        @click="showFullImage(image)"
        :src="getImageUrl(image)"
        v-for="image in theory.images"
        :key="image.id"
        style="border-radius: 20px"
      />
    </div>
  </div>
</template>

<script>
import { SERVER_URL } from "../../../axios";
import VideoPlayer from "../../../components/VideoPlayer.vue";
export default {
  components: { VideoPlayer },
  name: "TheoryPracticeLessonTheory",
  props: ["theory"],
  methods: {
    getImageUrl(image) {
      const splittedPath = image.path.split(".");
      const extension = splittedPath[splittedPath.length - 1];
      const url = `${SERVER_URL}/lessonsImages/${image.id}.${extension}`;
      return url;
    },
    showFullImage(image) {
      const url = this.getImageUrl(image);
      window.open(url, "_blank");
    },
  },
  computed: {
    getDropboxLink() {
      let courseLink = this.theory && this.theory.link ? this.theory.link : "";
      if (courseLink.includes("dropbox")) {
        const videoLink = courseLink.replace("dl=0", "raw=1");
        return videoLink;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.box {
  margin: 1rem 0px 4rem 0px;
  padding: 50px;
  max-width: 100vw !important;
}
.video {
  margin: 0 auto;
  margin-bottom: 2rem;
  max-width: 500px;
}
.images {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}
.images img {
  height: 300px;
  cursor: pointer;
  object-fit: cover;
  max-width: 100vw !important;
}
::v-deep p img {
  max-width: min(100%, 500px) !important;
  max-width: 100vw !important;
}
.description ::v-deep p {
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.description ::v-deep img {
  max-width: min(100%, 500px) !important;
  height: auto !important;
  width: auto !important;
  display: block;
  object-fit: contain;
  margin: 1rem auto;
}

@media screen and (max-width: 800px) {
  .box {
    padding: 20px;
  }
}
@media screen and (max-width: 500px) {
  .box {
    padding: 0px;
  }
}
</style>
